import { render } from "./vertical-sidebar.vue?vue&type=template&id=1679f2c2"
import script from "./vertical-sidebar.vue?vue&type=script&lang=js"
export * from "./vertical-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__